import { CardBrandList } from '~/components/card/CardBrandList'
import { DetailItem, PcDetailItem } from '~/components/plan/PlanDetail'
import { useIsPC } from '~/lib/ua'
import { css } from '~/styled-system/css'
import { vstack } from '~/styled-system/patterns'
import { Section } from './Section'

export function CancelGuardInfo({ plan }: { plan: { isCancelGuard: boolean } }) {
  const isPC = useIsPC()
  if (!plan.isCancelGuard) {
    return null
  }
  const Item = isPC ? PcDetailItem : DetailItem
  return (
    <Item title="キャンセル料のカード決済について">
      <CancelGuardInfoBody />
    </Item>
  )
}

function CancelGuardInfoBody() {
  return (
    <Section>
      <div
        className={vstack({ gap: '3', alignItems: 'start', fontSize: { base: 'sm', _pc: 'md' } })}
      >
        <p>※当プランはキャンセル料のみカード決済のプランです。</p>
        <p>
          キャンセル料が発生した場合にのみ、予約時に登録したクレジットカードにてキャンセル料をいただきます。キャンセル料についてはキャンセルポリシーをご確認ください。
        </p>
        <div>
          <p className={css({ mb: '2', fontWeight: 'bold' })}>ご利用いただけるクレジットカード</p>
          <CardBrandList />
        </div>
      </div>
    </Section>
  )
}
